import React from 'react';
import { SearchIcon, FilterIcon, MailIcon, BarChart3Icon } from 'lucide-react';
const steps = [{
  number: '1',
  icon: SearchIcon,
  title: 'Search accounting firms',
  description: 'Use our local business search to find accounting firms by location, specialization, firm size, or revenue range.'
}, {
  number: '2',
  icon: FilterIcon,
  title: 'Filter & segment',
  description: 'Build targeted lists of CPAs, tax preparers, bookkeepers, or audit specialists. Filter by city, state, or custom criteria.'
}, {
  number: '3',
  icon: MailIcon,
  title: 'Launch email sequences',
  description: 'Send personalized email campaigns directly to accounting owner contacts with our built-in sequencing tool.'
}, {
  number: '4',
  icon: BarChart3Icon,
  title: 'Track & optimize',
  description: 'Monitor open rates, reply rates, and conversions. Refine your accounting email list based on engagement data.'
}];
export function AccountingWorkflow() {
  return <section className="py-24 bg-white" data-id="element-501">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-502">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-503">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-504">
            How to use the{' '}
            <span className="text-blue-600" data-id="element-505">accounting database</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-506">
            From search to outreach in minutes. No complex setup, no data
            exports, no third-party tools required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-507">
          {steps.map((step, index) => <div key={step.number} className="relative" data-id="element-508">
              <div className="flex flex-col items-center text-center" data-id="element-509">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-2xl flex items-center justify-center mb-6 text-2xl font-bold shadow-lg shadow-blue-600/20" data-id="element-510">
                  {step.number}
                </div>
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-511">
                  <step.icon className="w-6 h-6" data-id="element-512" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-513">
                  {step.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed" data-id="element-514">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-8 left-[calc(50%+2rem)] w-[calc(100%-4rem)] h-0.5 bg-gradient-to-r from-blue-600 to-blue-300" data-id="element-515"></div>}
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-516">
          <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition-colors text-lg" data-id="element-517">
            Start building your list
          </a>
        </div>
      </div>
    </section>;
}